export const cohortBuilderHeaderMessagesEn = {
  // Cohort Builder Breadcrumbs
  'projects.cohortBuilderPage.breadcrumbs.projects': 'Projects',
  'projects.cohortBuilderPage.breadcrumbs.cohorts': 'Cohorts',

  // Cohort Builder Actions
  // M4 visual audit: simplified label — the button always processes the
  // current asset, so the asset type is redundant ("Process" matches the
  // analytical-dataset header).
  'projects.cohortBuilderPage.header.processButton': 'Process',
  // TODO: cleanup with skip_process_confirmation_modal ff
  'projects.cohortBuilderPage.header.processButton.queuing': 'Queuing…',
  // TODO: cleanup with skip_process_confirmation_modal ff
  'projects.cohortBuilderPage.header.processError':
    'The cohort could not be processed. Please try again.',
  'projects.cohortBuilderPage.header.saveButton': 'Save',
  'projects.cohortBuilderPage.header.undoButton': 'Revert',
  'projects.cohortBuilderPage.header.unsavedChanges': 'Unsaved changes',
  'projects.cohortBuilderPage.header.avErrors':
    '{count, plural, one {# error needs} other {# errors need}} to be resolved',
  'projects.cohortBuilderPage.header.showResearchAssistantButton': 'Use Research Assistant (beta)',
  'projects.cohortBuilderPage.header.hideResearchAssistantButton': 'Use cohort builder',
  'projects.cohortBuilderPage.header.saveProcessTooltip.processing': 'Processing cohort…',
  'projects.cohortBuilderPage.header.saveProcessTooltip.raProcessing':
    'Waiting for Research Assistant...',
  'projects.cohortBuilderPage.header.saveProcessTooltip.hasErrors': 'Fix errors before processing.',
  'projects.cohortBuilderPage.header.saveTooltip.noUnsavedChanges': 'No unsaved changes.',
  'projects.cohortBuilderPage.header.undoTooltip.noChanges': 'No unsaved changes.',
  'projects.cohortBuilderPage.header.undoTooltip.processing':
    'Reverting is disabled because the cohort is currently processing.',
  'projects.cohortBuilderPage.header.undoTooltip.raProcessing':
    'Reverting is disabled because the Research Assistant is currently processing.',
  'projects.cohortBuilderPage.header.undoTooltip.autoSaving':
    'Reverting is disabled because changes are being saved.',
  'projects.cohortBuilderPage.header.processTooltip.notFullyDefined':
    'Set an index date to process.',
  'projects.cohortBuilderPage.header.processTooltip.notFullyDefinedRestricted':
    'Set an index date to process.',
  'projects.cohortBuilderPage.header.processTooltip.dependentDatasetProcessing':
    'Processing is disabled while a dependent analytical dataset is currently processing.',
  'projects.cohortBuilderPage.header.processTooltip.duplicateCriteria':
    'Remove the duplicate criterion before processing.',

  // Cohort Builder Page Tabs
  'projects.cohortBuilderPage.pageTabs.resultsTab': 'Results',
  'projects.cohortBuilderPage.pageTabs.definitionTab': 'Definition',
  'projects.cohortBuilderPage.pageTabs.historyTab': 'History',
  'projects.cohortBuilderPage.pageTabs.eventsTab': 'Events',
  'projects.cohortBuilderPage.pageTabs.conceptsTab': 'Concepts',
  'projects.cohortBuilderPage.pageTabs.datasetsTab': 'Datasets',

  // Process Cohort Definition Modal
  'projects.cohortBuilderPage.processCohortDefinitionModal.title': 'Process cohort',
  'projects.cohortBuilderPage.processCohortDefinitionModal.confirmTitle': 'Confirm process cohort',
  'projects.cohortBuilderPage.processCohortDefinitionModal.message1':
    'This action will save the cohort and queue it for processing.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.message2':
    'The cohort status will be updated from {draft} to {processing}.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.message3':
    'Once processing is complete, the status will be updated to {processed} and the subjects and results will be available.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.draft': 'Draft',
  'projects.cohortBuilderPage.processCohortDefinitionModal.processing': 'Processing',
  'projects.cohortBuilderPage.processCohortDefinitionModal.ready': 'Ready',

  'projects.cohortBuilderPage.processCohortDefinitionModal.entrySaveButtonText': 'Process cohort',
  'projects.cohortBuilderPage.processCohortDefinitionModal.entryCancelButtonText':
    'Continue editing',

  'projects.cohortBuilderPage.processCohortDefinitionModal.retryBtn': 'Retry',
  'projects.cohortBuilderPage.processCohortDefinitionModal.returnBtn': 'Return to cohorts list',
  'projects.cohortBuilderPage.processCohortDefinitionModal.successTitle': 'Success',
  'projects.cohortBuilderPage.processCohortDefinitionModal.successText':
    '"{cohortName}" has been saved and processing was queued successfully.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.appErrorTitle': 'Application Error',
  'projects.cohortBuilderPage.processCohortDefinitionModal.systemErrorTitle': 'System Error',
  'projects.cohortBuilderPage.processCohortDefinitionModal.errorStatus': 'Status code: {status}',
  'projects.cohortBuilderPage.processCohortDefinitionModal.errorStatusWithOrg':
    'Status code: {status}, orginal status: {originalStatus}',

  // Save Cohort Definition Modal
  'projects.cohortBuilderPage.saveCohortDefinitionModal.title': 'Save cohort',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.confirmTitle': 'Confirm save cohort',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.message1':
    'This action will clear all processed data associated with the cohort.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.message2':
    'The cohort status will be updated from {processed} to {draft}.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.processed': 'Processed',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.draft': 'Draft',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.final': 'Final',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.savingTitle': 'In progress',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.description4':
    'Please wait while the cohort saves.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.saveBtn': 'Save cohort',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.retryBtn': 'Retry',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.cancelBtn': 'Continue editing',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.returnBtn': 'Return to cohorts list',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.successTitle': 'Success',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.successText':
    '"{cohortName}" was saved successfully.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.successMessageText':
    'This window will close automatically in {countDown} seconds.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.errorTitle': 'System Error',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.errorMessage': 'Please try again later.',

  // Translation failure
  'projects.cohortBuilderPage.modal.translationFailed':
    'The cohort definition could not be translated. Please review your criteria for errors.',

  // Exit the cohort builder
  'projects.cohortBuilderPage.cohortExitModal.title': 'Exit cohort builder',
  'projects.cohortBuilderPage.cohortExitModal.confirmTitle': 'Confirm exit cohort builder',
  'projects.cohortBuilderPage.cohortExitModal.message1':
    'This action will discard all changes made since the cohort was last saved.',
  'projects.cohortBuilderPage.cohortExitModal.processBtn': 'Continue editing',
  'projects.cohortBuilderPage.cohortExitModal.cancelBtn': 'Exit cohort builder',

  // Results page — staged changes warning (explicit_save path)
  'projects.cohortBuilderPage.results.stagedChangesWarning':
    'You have unsaved changes to the cohort definition. These results may be out of sync with the current definition.',

  // Read-only lock — cohort referenced by an analytical dataset's latest
  // version. Only shown while `asset_edit_while_in_use` is off.
  // TODO: cleanup with asset_edit_while_in_use ff
  'projects.cohortBuilderPage.analyticalDatasetLock.banner':
    'This cohort is read-only because it is used in the following {count, plural, one {analytical dataset} other {analytical datasets}}: {datasets}.',

  // Stale-dependency warning — an analytical variable this cohort depends on
  // changed since this cohort was last saved/processed (OR-6311).
  // TODO: cleanup with av_edit_while_in_use ff
  'projects.cohortBuilderPage.staleAnalyticalVariablesWarning':
    'One or more analytical variables used in this cohort have changed since it was last processed. Reprocess to update your results.',

  // Save failure pill state (explicit_save path)
  'projects.cohortBuilderPage.saveFailure.message': "Couldn't save your changes",
  'projects.cohortBuilderPage.saveFailure.retry': 'Retry',
  'projects.cohortBuilderPage.saveFailure.cancel': 'Cancel',
};
